import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { bonuses } from '../../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonuses-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-57" data-mp="16m0vlgnh87es">
      <div className="mx-auto max-w-5xl" data-id="element-58" data-mp="1bjiyapawhqec">
        <div className="flex justify-center" data-id="element-59" data-mp="1bi7skjxwa8kl">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-ivory" data-id="element-60" data-mp="wms5iyvqfcxp">
            <GiftIcon className="h-5 w-5 text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-61" data-mp="11mehz63qkp5g" />
          </span>
        </div>
        <SectionHeading id="bonuses-heading" eyebrow="You Also Get" title="And That's Not All..." body="Get 5 additional instructor resources designed to make your classes even easier to prepare and deliver." className="mt-5" data-id="element-62" data-mp="nnoi5ipj8bde" />

        <ol className="mt-12 grid gap-6 md:grid-cols-2" role="list" data-id="element-63" data-mp="2myfymvcjc210">
          {bonuses.map((bonus, index) => <li key={bonus.number} className={`flex h-full flex-col overflow-hidden rounded-[20px] bg-white shadow-[0_24px_50px_-36px_rgba(90,70,40,0.45)] ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-64" data-mp="1k6amhzsgfyqw" data-mpi={index}>
              <div className="px-6 py-3" style={{
            backgroundColor: bonus.accent
          }} data-id="element-65" data-mp="1ozvcb4jw9mf0">
                <p className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/80" data-id="element-66" data-mp="1187v5ecfpppx">
                  {bonus.number}
                </p>
              </div>
              <div className="flex flex-1 flex-col px-6 py-7 sm:px-8" data-id="element-67" data-mp="1b7oy3o0axpi7">
                <h3 className="font-display text-[1.5rem] font-bold leading-snug text-brand-charcoal" data-id="element-68" data-mp="1b4t0y1wa34ut">{bonus.title}</h3>
                <p className="mt-2.5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-69" data-mp="2mm2jmm7l1sv2">{bonus.description}</p>
                <p className="mt-auto flex items-center gap-1.5 self-start pt-5 font-body text-[11px] font-bold uppercase tracking-[0.14em] text-brand-cta" data-id="element-70" data-mp="2ho0xttirvffw">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" data-id="element-71" data-mp="2pq9xvsku4gd1" />
                  {bonus.badge}
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-72" data-mp="2ymsqf3p5m293">
          Lessons. Activities. Visuals. Assessments. Organization. <Accent data-id="element-73" data-mp="2az10uyelrspv">Already done for you.</Accent>
        </p>
      </div>
    </section>;
}